package org.gstechnovos.jexonplastech.sections.about.sections

import androidx.compose.runtime.Composable
import org.gstechnovos.jexonplastech.components.widgets.GlobalCtaData
import org.gstechnovos.jexonplastech.components.widgets.GlobalCtaWidget

// ==========================================
// CMS DATA MODEL
// ==========================================

// We define the static default data specific to the About Page here,
// keeping the global widget completely clean and data-agnostic.
/**
 *
 * Text:
 * Headline: Limit to 4–7 words (e.g., "Ready to Experience Jexon Quality?").
 *
 * Description: Limit to 1–2 sentences so it doesn't overwhelm the call to action.
 *
 * Button Text: Limit to 2–4 words (e.g., "Contact Our Team").
 *
 */
val defaultAboutCtaData = GlobalCtaData(
    headline = "Ready to Experience Jexon Quality?",
    description = "Reach out to our team to discuss custom manufacturing, vendor pricing, and our complete catalog.",
    buttonText = "Contact Our Team",
    buttonPath = "/contact"
)

// ==========================================
// COMPONENT
// ==========================================

@Composable
fun AboutCtaSection(data: GlobalCtaData = defaultAboutCtaData) {
    // Simply render the global widget using this section's specific data
    GlobalCtaWidget(data = data)
}